import { useMemo } from 'react';
import { accountApi } from '@netiva/classifieds-api';
import { useAppSelector } from '@/store';

export const useAdContactPersons = () => {
  const { contactPersonIds: selectedContactPersonIds } = useAppSelector((state) => state.ad);

  const { data: contactPersonData, isLoading } = accountApi.useGetContactPerson({});
  const contactPersons = useMemo(() => contactPersonData?.contactPersons || [], [contactPersonData?.contactPersons]);
  const assignedContactPersons = useMemo(
    () => contactPersons.filter((c) => selectedContactPersonIds.includes(c.id)),
    [contactPersons, selectedContactPersonIds]
  );

  return {
    contactPersons,
    isLoading,
    assignedContactPersons,
  };
};
